import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "jhm-photo-preview",
	templateUrl: "./photo-preview.html",
	styleUrls: ["./photo-preview.scss"],
	standalone: true
})
export class PhotoPreviewComponent
{
	@Input()
	public photoPreviewUrl: string;
	@Input()
	public filename: string;
	@Input()
	public isAdmin: boolean = false;
	@Output()
	public deleteClicked: EventEmitter<void> = new EventEmitter<void>();
	@Output()
	public approveClicked: EventEmitter<void> = new EventEmitter<void>();
	@Output()
	public rejectClicked: EventEmitter<void> = new EventEmitter<void>();
}
